import { useState } from "react";
import { Mail, CheckCircle2 } from "lucide-react";
import api, { errMsg } from "@/lib/api";
import { toast } from "@/components/ui/sonner";
import Reveal from "@/components/Reveal";

export default function NewsletterSection() {
  const [email, setEmail] = useState("");
  const [done, setDone] = useState(false);
  const [loading, setLoading] = useState(false);

  const subscribe = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post("/newsletter/subscribe", { email });
      toast.success(data.already ? "Vous êtes déjà inscrit(e) !" : "Inscription confirmée — bienvenue dans la famille !");
      setDone(true);
    } catch (err) {
      toast.error(errMsg(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <section className="mx-auto max-w-7xl px-4 pb-16 sm:px-8" data-testid="newsletter-section">
      <Reveal>
        <div className="card-tactical relative overflow-hidden p-8 sm:p-12">
          <Mail className="absolute -left-6 -top-6 h-40 w-40 text-orange-500/10" />
          <div className="flex flex-wrap items-center justify-between gap-8">
            <div className="max-w-lg">
              <p className="text-xs font-bold uppercase tracking-[0.2em] text-orange-500">Newsletter</p>
              <h2 className="mt-2 text-2xl font-extrabold uppercase tracking-tight sm:text-3xl">
                Ne ratez aucun drop
              </h2>
              <p className="mt-3 text-sm text-slate-400">
                Recevez en avant-première les nouveaux maillots, les codes promo exclusifs et les résultats de l'équipe.
                Zéro spam, que de l'Emisphere.
              </p>
            </div>
            {done ? (
              <p className="flex items-center gap-2 rounded-xl border border-emerald-500/40 bg-emerald-500/10 px-5 py-4 text-sm font-bold text-emerald-400" data-testid="newsletter-success">
                <CheckCircle2 className="h-5 w-5" /> Inscription enregistrée. À très vite !
              </p>
            ) : (
              <form onSubmit={subscribe} className="flex w-full max-w-md gap-3">
                <input type="email" placeholder="votre@email.fr" value={email} required
                  data-testid="newsletter-email-input" onChange={(e) => setEmail(e.target.value)}
                  className="flex-1 rounded-lg border border-input bg-[#060B18] px-4 py-3 text-sm text-white placeholder:text-slate-500 focus:outline-none focus:ring-2 focus:ring-orange-500" />
                <button type="submit" disabled={loading} data-testid="newsletter-subscribe-button"
                  className="glow-orange shrink-0 rounded-xl bg-orange-500 px-6 py-3 font-heading text-base font-bold uppercase tracking-wide text-[#060B18] transition-all hover:scale-[1.02] hover:bg-orange-400 active:scale-[0.98] disabled:opacity-50">
                  {loading ? "..." : "S'inscrire"}
                </button>
              </form>
            )}
          </div>
        </div>
      </Reveal>
    </section>
  );
}
